import request from '@/utils/request'



// 查询商家进件-拉卡拉分页
export function pageExtraApplyUms(query) {
  return request({
    url: '/biz/admin/merchant/extra/apply/chinaums/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家进件-拉卡拉详细
export function getExtraApplyUms(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/chinaums/detail',
    method: 'get',
    params: data
  })
}


// 修改商家进件-拉卡拉
export function updateExtraApplyUms(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/chinaums/edit',
    method: 'post',
    data: data
  })
}


// 三方进件
export function extraApplyUmsApply(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/chinaums/apply',
    method: 'get',
    params: data
  })
}


export function getUmsMerInfo(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/chinaums/mer/info',
    method: 'get',
    params: data
  })
}

export function getUmsMerBalance(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/chinaums/mer/balance',
    method: 'get',
    params: data
  })
}

